<template>
    <div class="User">
        <!-- <myBreadcrumbs :urls="JSON.stringify(breadcrumbs)" :icon="icon" >
        </myBreadcrumbs> -->

        <create-dialog ref="createDialog" v-model="dialog"></create-dialog>

        <!-- Datatable -->
        <v-card>
            <v-card-title>
                <span style="text-transform: uppercase;" class="text-subtitle-1">Danh sách người dùng</span>

                <v-divider vertical class="ml-4"></v-divider>
                
                <vue-excel-xlsx
                    :data="items.map(x=> {
                        return {
                            code: x.employeeCode,
                            name: x.employeeName,
                            role: x.userRoles.map(c => c.roleName).join(',')

                        }
                    })"
                    :columns = "[
                        {label: 'Mã NS', field: 'code' },
                        {label: 'Tên NS', field: 'name' },
                        {label: 'Role', field: 'role' }
                    ]"
                    :file-name="'DU_LIEU_USER'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    >
                        <v-btn color="teal darken-4" text style="text-transform: capitalize;">Xuất excel</v-btn>
                        <!-- <v-btn color="green" class="mx-2 my-1" small dark> <v-icon left>mdi-microsoft-excel</v-icon>Xuất dữ liệu</v-btn> -->
                </vue-excel-xlsx>
            <v-spacer></v-spacer>
            

            <v-btn color="teal darken-4" small dark @click="openDialog">{{ $t('view.action.create') }}</v-btn>
            <!-- <create-button @click="openDialog"></create-button> -->
            </v-card-title>
            <v-card-text>
                <v-tabs
                    v-model="tab"
                    background-color="teal darken-4"
                    centered
                    dark
                    icons-and-text
                    >
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab href="#tab-1">
                        Tài khoản nhân viên
                        <v-icon>mdi-account</v-icon>
                    </v-tab>

                    <v-tab href="#tab-2">
                        Tài khoản admin
                        <v-icon>mdi-account-hard-hat</v-icon>
                    </v-tab>

                    <v-tab href="#tab-3">
                        Tài khoản API & test
                        <v-icon>mdi-account-convert</v-icon>
                    </v-tab>
                    
                    <v-tab href="#tab-4">
                        Lịch sử thao tác
                        <v-icon>mdi-history</v-icon>
                    </v-tab>
                    
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item value="tab-1"
                        >
                            <v-card flat>
                            <v-card-text>
                                <v-data-table height="600px" :mobile-breakpoint="0" lazy
                                :headers="headers" :loading="isLoading"
                                :items="items"
                                :footer-props="{
                                    itemsPerPage: 10000,
                                    itemsPerPageOptions:[
                                        15, 50, 100, 200, 10000
                                    ]
                                }"
                                >
                                    <template v-slot:[`body.prepend`]="" >
                                        <tr class="filter">
                                            <td></td>
                                            <td>
                                                <v-text-field v-model="filters.employeeCode" :label="$t('view.filter.type_placeholder')" dense outlined hide-details></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field v-model="filters.employeeName" :label="$t('view.filter.type_placeholder')" dense outlined hide-details></v-text-field>
                                            </td>
                                            <!-- <td>
                                                <v-autocomplete v-model="filters.departmentCode" :items="departments" item-value="code" item-text="name" clearable :label="$t('view.filter.type_placeholder')" dense outlined hide-details></v-autocomplete>
                                            </td> -->
                                            <td>
                                                <v-text-field v-model="filters.code" :label="$t('view.filter.type_placeholder')" dense outlined hide-details></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field v-model="filters.userName" :label="$t('view.filter.type_placeholder')" dense outlined hide-details></v-text-field>
                                            </td>
                                            <td colspan="100%"></td>
                                        </tr>
                                    </template>
                                    <template v-slot:[`item.userName`]="{ item }">
                                        <b>{{ item.userName }}</b>
                                    </template>
                                    <template v-slot:[`item.userRoles`]="{ item }">
                                        <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="light-green" dark class="ma-2 caption font-weight-bold" label>
                                            {{role.roleName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.isActive`]="{ item }">
                                        <v-icon v-if="item.isActive" color="success">mdi-check</v-icon>
                                        <v-icon v-else color="error">mdi-close</v-icon>
                                    </template>
                                    <template v-slot:[`item.usedDevice`]="{ item }">
                                        
                                        <v-tooltip left eager v-if="!!item.usedDevice">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="black" dark  v-if="item.usedDevice.length>16" @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-apple</v-icon>
                                                </v-btn>
                                                <v-btn color="light-green" dark v-else @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-android</v-icon>
                                                </v-btn>
                                            </template>
                                        <span>{{item.usedDevice}}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.departmentName`]="{ item }">
                                        <v-chip class="ma-2 caption font-weight-bold" color="orange" label text-color="white" >
                                            <v-icon left>
                                                mdi-store
                                            </v-icon>
                                            {{item.departmentName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <edit-button @click="editItem(item)"></edit-button>
                                        <delete-button @click="deleteItem(item)"></delete-button>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-2"
                        >
                            <v-card flat>
                            <v-card-text>
                                <v-data-table height="600px" :mobile-breakpoint="0" lazy
                                :headers="headers"
                                :items="admins"
                                :footer-props="{
                                    itemsPerPage: 10000,
                                    itemsPerPageOptions:[
                                        15, 50, 100, 200, 10000
                                    ]
                                }"
                                >
                                    <template v-slot:[`item.userName`]="{ item }">
                                        <b>{{ item.userName }}</b>
                                    </template>
                                    <template v-slot:[`item.userRoles`]="{ item }">
                                        <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="light-green" dark class="ma-2 caption font-weight-bold" label>
                                            {{role.roleName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.isActive`]="{ item }">
                                        <v-icon v-if="item.isActive" color="success">mdi-check</v-icon>
                                        <v-icon v-else color="error">mdi-close</v-icon>
                                    </template>
                                    <template v-slot:[`item.usedDevice`]="{ item }">
                                        
                                        <v-tooltip left eager v-if="!!item.usedDevice">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="black" dark  v-if="item.usedDevice.length>16" @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-apple</v-icon>
                                                </v-btn>
                                                <v-btn color="light-green" dark v-else @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-android</v-icon>
                                                </v-btn>
                                            </template>
                                        <span>{{item.usedDevice}}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.departmentName`]="{ item }">
                                        <v-chip class="ma-2 caption font-weight-bold" color="orange" label text-color="white" >
                                            <v-icon left>
                                                mdi-store
                                            </v-icon>
                                            {{item.departmentName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <edit-button @click="editItem(item)"></edit-button>
                                        <delete-button @click="deleteItem(item)"></delete-button>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-3"
                        >
                            <v-card flat>
                            <v-card-text>
                                <v-data-table height="600px" :mobile-breakpoint="0" lazy
                                :headers="headers"
                                :items="services"
                                :footer-props="{
                                    itemsPerPage: 10000,
                                    itemsPerPageOptions:[
                                        15, 50, 100, 200, 10000
                                    ]
                                }"
                                >
                                    <template v-slot:[`item.userName`]="{ item }">
                                        <b>{{ item.userName }}</b>
                                    </template>
                                    <template v-slot:[`item.userRoles`]="{ item }">
                                        <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="light-green" dark class="ma-2 caption font-weight-bold" label>
                                            {{role.roleName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.isActive`]="{ item }">
                                        <v-icon v-if="item.isActive" color="success">mdi-check</v-icon>
                                        <v-icon v-else color="error">mdi-close</v-icon>
                                    </template>
                                    <template v-slot:[`item.usedDevice`]="{ item }">
                                        
                                        <v-tooltip left eager v-if="!!item.usedDevice">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="black" dark  v-if="item.usedDevice.length>16" @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-apple</v-icon>
                                                </v-btn>
                                                <v-btn color="light-green" dark v-else @click="clearDevice(item)"
                                                v-bind="attrs" v-on="on" icon>
                                                    <v-icon>mdi-android</v-icon>
                                                </v-btn>
                                            </template>
                                        <span>{{item.usedDevice}}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.departmentName`]="{ item }">
                                        <v-chip class="ma-2 caption font-weight-bold" color="orange" label text-color="white" >
                                            <v-icon left>
                                                mdi-store
                                            </v-icon>
                                            {{item.departmentName}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <edit-button @click="editItem(item)"></edit-button>
                                        <delete-button @click="deleteItem(item)"></delete-button>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>
                        
                        <v-tab-item value="tab-4"
                        >
                            <v-card flat>
                                <v-card-text>
                                    <v-data-table :headers="headerLogs" :items="logs">
                                        <template v-slot:[`item.updatedAt`]="{ item }">
                                            {{ formatDate(item.updatedAt, true) }}
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
            </v-card-text>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                    <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
        
        <!-- <v-card class="mt-5">
            <v-card-title>
                {{$t('view.user.logs')}} 
            </v-card-title>
            <v-card-text>
            </v-card-text>
        </v-card> -->
    </div>
</template>

<script>

import CreateButton from '@/components/Crud/CreateButton';
import createDialog from './Create'
import http from '@/components/services/http-common';
import ApiService from '@/components/services/ApiServices';
import * as moment from "moment/moment"

const ClearDeviceURL = "users/clear-device/"

export default {
    name: "User-index",
    components: {
        CreateButton,
        "create-dialog": createDialog
    },
    computed:{
        params: function() {
            return {...this.tableParams, ...this.filters}
        }
    },
    watch: {
        options: {
        handler (val) {
            this.fetchData();
        },
        deep: true,
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler: _.debounce(function(){
                    this.tableParams.page=1;
                    this.fetchData();
                }, 500),
            deep: true,
        },
    },
    methods: {
        
        convertToExcelLabel(value) {
            if(Array.isArray(value)) {
                var exceptCols = ['actions', 'images']
                return value.filter(x=>!exceptCols.includes(x.value)).map(x => {
                    return {
                        label: x.text,
                        field: x.value
                    }
                })
            }
        },
        
        formatDate(value, hasTime = false) {
            if(hasTime == false)
                return moment(value).format("DD/MM/YYYY");
            else 
                return moment(value).format("DD/MM/YYYY hh:mm:ss");
        },
        openDialog(){
            this.dialog = true;
        },
        fetchData() {
            this.isLoading = true
            return http.get('users',{
                params: this.params
            }).then(res => {
                this.items = res.data.users;
                this.admins = res.data.admins;
                this.services = res.data.services;
                this.rowCount = res.data.rowCount;
            }).catch(err => {

            }).finally(() => {this.isLoading = false})
        },
        fetchDepartment(){
            ApiService.fetchDepartment().then(res => {
                this.departments = res.data;
            })
        },

        fetchLogs() {
            return http.get("users/fetch/log").then(res => {
                this.logs = res.data.logs
            })
        },

        cfmDeleteItem() {
            http.delete("users/"+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                console.log(err);
            });
        },
        editItem(item) {
            this.$refs.createDialog.isUpdate = true;
            this.$refs.createDialog.item = item;
            this.$refs.createDialog.fetchUpdate(item.code);
            this.$refs.createDialog.dialog = true;
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        clearDevice(item)
        {
            console.log("111")
            return http.get(ClearDeviceURL+item.code).then(res => {
                this.fetchData();
            })
        }
    },
    mounted () {
        this.fetchDepartment()
        this.fetchData()
        this.fetchLogs()
    },
    data() {
        return {
            tab: 1,

            search: "",
            totalItem: 0,
            isLoading: true,
            dialogDelete: false,
            dialog: false,
            // options: {},
            items: [],
            admins: [],
            services: [],
            createDialog: false,
            
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 10000
            },
            departments:[],
            filters:{
                employeeCode:null,
                employeeName:null,
                code:null,
                userName:null,
            },
            rowCount: 0,
            
            headers: [
                { text: this.$t('view.user.action'), value: 'actions', sortable: false, width: '7rem'},
                { text: this.$t('view.user.employee_code'), value: 'employeeCode', width:150 },
                { text: this.$t('view.user.employee_name'), value: 'employeeName', width:200 },
                // { text: this.$t('view.user.action'), value: 'departmentName', width:200 },
                { text: this.$t('view.user.user_code'), value: 'code',width: 150 },
                { text: this.$t('view.user.user_name'), align: 'start', sortable: false, value: 'userName', width:200},
                { text: this.$t('view.user.is_active'), value: 'isActive' },
                { text: this.$t('view.user.permission'), value: 'userRoles', sortable: false},
                // { text: this.$t('view.user.device'), value: 'usedDevice', sortable: false},
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },

            logs: [],
            headerLogs: [
                // { text: 'Thao tác', value: 'resource', sortable: false, width: '7rem'},
                { text: this.$t('view.user.action'), value: 'action', width:150 },
                { text: this.$t('view.user.user_code'), value: 'code', width:200 },
                { text: this.$t('view.user.updated_by'), value: 'updatedBy', width:200 },
                { text: this.$t('view.user.updated_at'), value: 'updatedAt', width:200 },
            ]
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>